// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price-37z-y";
var _3 = "button-Gy5-B";
var _4 = "selectFrom_best-1rfvC";
var _5 = "seats-3CAgM";
export { _1 as "__esModule", _2 as "price", _3 as "button", _4 as "selectFrom_best", _5 as "seats" }
export default { "__esModule": _1, "price": _2, "button": _3, "selectFrom_best": _4, "seats": _5 }
